export enum SessionStorageKeyTypes {
  reviewPopupClosedByUser = 'reviewPopupClosedByUser',
  eventQueue = 'eventQueue',
  isLoggedIn = 'isLoggedIn',
}

export enum SessionStorageValueTypes {
  closed = 'closed',
}
